import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import {
  PricingSchemeEventContainerModel
} from '../../../../../../models/aggregates/erp/pricing-scheme/pricing-scheme-event-container.model';
// import { PricingSchemeEventContainerModel } from '../../../../../../models/aggregates/erp/price-book/pricing-scheme-event-container.model';

@Injectable({ providedIn: 'root' })
export class PricingSchemeEventService extends BaseApiTemplateService<PricingSchemeEventContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricing-scheme-events';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricing-scheme-events';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricing-scheme-events';
    this.httpClient = http;
  }
}
